import axios from 'axios';
import { url } from '../config';

import { FETCH_POSTS, FETCH_POSTS_START } from '../actions/index.jsx';

export const fetchPostByAuthor = (author_id) => {
    return function (dispatch) {
        dispatch({ type: FETCH_POSTS_START });
        axios
            .get(`${url}/wp-json/wp/v2/posts?author=${author_id}`)
            .then((response) => {
                dispatch({
                    type: FETCH_POSTS,
                    payload: response.data,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/author_request.js